import React, { useState } from 'react';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import Button from '@mui/material/Button';
import { SVGS } from '../assets';
import './business-category.scss';
import { SignUpContainer } from '../sign-up-container/sign-up-container';
import { SellerDetails } from '@zonofi/zo-types';
import { JTBDEventType, useEventTracking } from '@zonofi/seller-rtk-store';

interface BusinessCategoryProps {
  goBack: () => void;
  setYourIndustry: () => void;
  sellerDetails: SellerDetails;
  onUpdateValue: (key: string, value: string) => void;
}

const categories = [
  {
    id: 'BRAND_OR_MANUFACTURER' as const,
    icon: SVGS.BrandManufacturerIcon,
    title: 'Brands/Manufacturer',
    description:
      'You create or own products under a brand and distribute them through a channel/network of distributors or retailers.',
  },
  {
    id: 'DISTRIBUTOR_OR_WHOLESALER' as const,
    icon: SVGS.DistributionIcon,
    title: 'Distributor/Wholesaler',
    description:
      'You purchase in bulk from brands or manufacturers and supply goods to retailers or smaller distributors.',
  },
  {
    id: 'RETAILER' as const,
    icon: SVGS.RetailerIcon,
    title: 'Retailer',
    description:
      'You sell products directly to end customers and operate via a physical store, online platform, or both.',
  },
];

export const BusinessCategory: React.FC<BusinessCategoryProps> = ({
  goBack,
  setYourIndustry,
  onUpdateValue,
  sellerDetails,
}) => {
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const { trackEvent } = useEventTracking();
  return (
    <SignUpContainer customClass="custom">
      <div className="businessDetails">
        <h2 className="primary-font-semibold seller-font-size-heading">
          What is your business category?
        </h2>
        <p className="primary-font-regular">
          Select the option that best describes your business type.
        </p>
        {showWarning && (
          <span className="primary-font-regular" style={{ color: 'red' }}>
            Please select a business category
          </span>
        )}

        <div className="businessCategory">
          <div className="category_sec">
            {categories.map((cat) => (
              <div
                key={cat.id}
                className={`cat_list ${
                  sellerDetails?.category === cat.id ? 'active' : ''
                }`}
                onClick={() => onUpdateValue('category', cat.id)}
              >
                <span className="radio-icon">
                  {sellerDetails?.category === cat.id ? (
                    <img src={SVGS.RadioCheckedIcon} width={24} height={24} />
                  ) : (
                    <img src={SVGS.RadioUncheckIcon} width={24} height={24} />
                  )}
                </span>
                <span className="icon">
                  <img src={cat.icon} width={55} height={55} alt="" />
                </span>
                <div>
                  <div className="primary-font-semibold cat_list-title">
                    {cat.title}
                  </div>
                  <p>{cat.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="details_bottomSec">
          <Button className="backbutton" variant="text" onClick={goBack}>
            <span>
              <img
                src={SVGS.ArrowLeftBlue}
                width={20}
                height={20}
                className="ArrowLeft"
              />
            </span>{' '}
            Back
          </Button>
          <ZoButton
            label="Continue"
            endIcon={
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={SVGS.ArrowRight}
                  width={20}
                  height={20}
                  className="ArrowRight"
                />
              </span>
            }
            onClick={() => {
              if (sellerDetails?.category) {
                setShowWarning(false);
                setYourIndustry();
                trackEvent(JTBDEventType.SIGNUP_BUSINESS_CATEGORY_SELECTED, {
                  ...sellerDetails,
                });
              } else {
                setShowWarning(true);
              }
            }}
            className="sign-up-now-btn"
          />
        </div>
      </div>
    </SignUpContainer>
  );
};
